import React from 'react';
import { Typography } from '@mui/material';

function Favorites() {
    return (
        <div>
            <Typography variant="body1">Favorites</Typography>
        </div>
    );
}

export default Favorites;